
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
	notificationWithdraws: 0,
};

const slice = createSlice({
	name: 'notificationWithdraws',
	initialState,
	reducers: {
		setNotificationWithdraws(state, action) {
			state.notificationWithdraws = action.payload;
		},
	},
});


// Actions
export const { setNotificationWithdraws } = slice.actions;

// ----------------------------------------------------------------------

// Reducer
export default slice.reducer;